define([
	"dojo/_base/declare",
	"csi/locale",
	"csi/heading/String"
],function(declare,locale,StringRen){

	return declare(StringRen, {
		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: disable filtering because of name change
			return null;
		},
		
		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: get value for Node Name attribute
			return locale.getNodeName(ctx.getNode(), ctx.cache, ctx.locale);
		}
	});
});